import type { Directive } from "vue";

const noAutocomplete: Directive = {
  mounted(el: HTMLElement) {
    // Se il nodo è un input diretto
    if (el.tagName === "INPUT") {
      el.setAttribute("autocomplete", "off");
      return;
    }

    // Altrimenti prova a trovare un input figlio (es. nei v-text-field o v-autocomplete)
    const input = el.querySelector("input");
    if (input) {
      input.setAttribute("autocomplete", "off");
    }
  },

  updated(el: HTMLElement) {
    // Rimuove eventuali modifiche successive
    const input = el.querySelector("input");
    if (input) {
      input.setAttribute("autocomplete", "off");
    }
  },
};

export default noAutocomplete;
